var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0352,
    cy: 20,
    r: 20,
    fill: "#DDEEF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1672 6.29492L9.36719 11.3747V27.9745H17.3672V19.1745H22.9672V11.3747L16.1672 6.29492ZM16.1672 10.3749C15.7272 10.3749 15.3672 10.0149 15.3672 9.57492C15.3672 9.13492 15.7272 8.77492 16.1672 8.77492C16.6072 8.77492 16.9672 9.13492 16.9672 9.57492C16.9672 10.0149 16.6072 10.3749 16.1672 10.3749Z",
    fill: "#49B7E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.168 19.9746V30.3746H33.368V19.9746H18.168ZM31.768 27.1746H31.368C30.688 27.1746 30.168 27.6946 30.168 28.3746V28.7746H21.368V28.3746C21.368 27.6946 20.848 27.1746 20.168 27.1746H19.768V23.1746H20.168C20.848 23.1746 21.368 22.6546 21.368 21.9746V21.5746H30.168V21.9746C30.168 22.6546 30.688 23.1746 31.368 23.1746H31.768V27.1746Z",
    fill: "#49B7E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4064 22.375H22.1264C21.9664 23.175 21.3664 23.775 20.5664 23.935V26.415C21.3664 26.575 21.9664 27.175 22.1264 27.975H29.4064C29.5664 27.175 30.1664 26.575 30.9664 26.415V23.935C30.1664 23.775 29.5664 23.175 29.4064 22.375ZM25.7664 26.375C25.0864 26.375 24.5664 25.855 24.5664 25.175C24.5664 24.495 25.0864 23.975 25.7664 23.975C26.4464 23.975 26.9664 24.495 26.9664 25.175C26.9664 25.855 26.4464 26.375 25.7664 26.375Z",
    fill: "#49B7E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSales);
export default __webpack_public_path__ + "static/media/total-sales.bc1367d1bcb1efe9d30ac2cb088bcfbb.svg";
export { ForwardRef as ReactComponent };